import { Box, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import { AudioConversationDetail } from '@/services/types/audio-conversation-types';

import { DetailedMatter } from '../../../services/types/client-intake-types';
import theme from '../../../theme/theme';
import { AudioConversationPlayer } from '../../audio-conversation';
import ClientScreenTile from '../../base/ClientScreenTile';

interface ReadOnlyIntakeCallSectionProps {
  matter: DetailedMatter;
}

const ReadOnlyIntakeCallSection: React.FC<ReadOnlyIntakeCallSectionProps> = ({
  matter,
}) => {
  const [playingConversationId, setPlayingConversationId] = useState<
    string | null
  >(null);
  const conversations = matter?.conversations || [];

  const handlePlay = (conversationId: string) => {
    setPlayingConversationId(conversationId);
  };

  if (conversations.length === 0) {
    return null;
  }

  return (
    <ClientScreenTile>
      <Stack spacing={3}>
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Box
            sx={{
              width: '100%',
              borderBottom: `1px solid ${theme.palette.border.main}`,
              paddingBottom: 3,
            }}
          >
            <Typography variant="h2">Intake Call</Typography>
          </Box>
        </Stack>
        {conversations.map((conversation) => (
          <Stack key={conversation.id} spacing={4}>
            <AudioConversationPlayer
              conversation={conversation as unknown as AudioConversationDetail}
              onPlay={() => handlePlay(conversation.id)}
              playingConversationId={playingConversationId}
              enableInspector={false}
            />
          </Stack>
        ))}
      </Stack>
    </ClientScreenTile>
  );
};

export default ReadOnlyIntakeCallSection;
